export default __webpack_public_path__ + "b4f95945595462e8893cded2c441e6d2.webp";